import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Trash } from "assets/icons";

interface DeleteConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  description?: string;
  confirmLabel?: string;
}

const DeleteConfirmDialog = ({ isOpen, onClose, onConfirm, description, confirmLabel }: DeleteConfirmDialogProps) => {
  return (
    <AlertDialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-1.5 text-status-bad">
            <Trash className="h-4 w-4" />
            Verwijder foto
          </AlertDialogTitle>
          <AlertDialogDescription>
            {description ?? "Wil je deze afbeelding verwijderen uit de Yallyhub? Zo ja, dan wordt deze ook van SharePoint verwijderd."}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose}>Nee, toch niet</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-status-bad text-white hover:bg-status-bad/90"
          >
            <Trash className="mr-1.5 h-4 w-4" />
            {confirmLabel ?? "Verwijder foto"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteConfirmDialog;
